// Card #3198 - the Queue page's Inbox: one row per class assigned to this
// scribe, with how many rides are cached for it and whether its last pull
// went wrong. Reads ONLY IndexedDB (docs/score/scribe-resilience.md I8), so
// it renders fully offline and imports no HTTP client.
//
// "Assigned to this scribe" is the same set the class list shows
// (useClassesForShow): the `classes.showScribe` index read plus the same
// isAssignedTo net. Per-class pull status is `meta.classPulls` (card #3195).
import { classes, rides, getMeta } from "./db";
import { compareByClassNumber, sortByScheduledTime } from "../util/classDisplay";
import { isAssignedTo } from "../util/scribeAssignment";

export const INBOX_FLAG = {
  PULL_FAILED: "pullFailed",
};

export async function buildInboxRows({ showId, sub }) {
  const lastPulledAt = (await getMeta("lastPulledAt")) ?? null;
  if (!showId || !sub) return { rows: [], lastPulledAt };
  const [cached, classPulls] = await Promise.all([
    classes.byShowForScribe(showId, sub),
    getMeta("classPulls").then((v) => v ?? {}),
  ]);
  const mine = sortByScheduledTime(
    cached.filter((c) => isAssignedTo(c, sub)),
    compareByClassNumber
  );
  const rows = await Promise.all(
    mine.map(async (klass) => {
      const rideCount = (await rides.byClass(klass.id)).length;
      const flags = [];
      if (classPulls[klass.id]?.status === "failed") flags.push(INBOX_FLAG.PULL_FAILED);
      return {
        classId: klass.id,
        classNumber: klass.classNumber ?? "",
        className: klass.className ?? "",
        rideCount,
        flags,
      };
    })
  );
  return { rows, lastPulledAt };
}
